import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/site/Marquee";
import { GeorgiaSpotlight } from "@/components/home/GeorgiaSpotlight";
import { ExploreBento } from "@/components/home/ExploreBento";
import { UpcomingTrips } from "@/components/home/UpcomingTrips";
import { DestinationRows } from "@/components/home/DestinationRows";
import { CallbackSection } from "@/components/home/CallbackSection";
import { FounderSection } from "@/components/home/FounderSection";
import { CountriesHighlight } from "@/components/home/CountriesHighlight";
import { GeorgiaFinale } from "@/components/home/GeorgiaFinale";
import { ReviewsSection } from "@/components/home/ReviewsSection";
import { StatsPartners } from "@/components/home/StatsPartners";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "Trippy Tastic | Georgia Tour & e-Visa Specialists, Delhi Travel Agency",
    description: "Trippy Tastic is a Delhi travel agency and India's Georgia specialist: Georgia e-visa help, Georgia tour packages, group trips, honeymoons and custom tours. Call +91 72176 02754.",
    path: "/",
  });
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <GeorgiaSpotlight />
      <ExploreBento />
      <CountriesHighlight />
      <UpcomingTrips />
      <DestinationRows />
      <ReviewsSection />
      <StatsPartners />
      <FounderSection />
      <CallbackSection />
      <GeorgiaFinale />
    </main>
  );
}
